// Mirrors client-service app/schemas/staff_settlement.py (the server is the authority).

import { fmtNum } from './format.ts'

export const RATE_MIN = 5000
export const RATE_MAX = 30000

export function rateRangeError(): string {
  return `Rate must be between ${fmtNum(RATE_MIN)} and ${fmtNum(RATE_MAX)}.`
}

export interface BankForm {
  bank_name: string
  account_number: string
  account_name: string
  currency: string
}

export function cleanAccountNumber(raw: string): string {
  return raw.replace(/[ -]/g, '')
}

export function validateBank(f: BankForm): Record<string, string> {
  const e: Record<string, string> = {}
  if (f.bank_name.trim().length < 2) e.bank_name = 'Enter the bank name (at least 2 characters).'
  if (!/^\d{6,20}$/.test(cleanAccountNumber(f.account_number.trim()))) {
    e.account_number = 'Enter 6 to 20 digits (spaces and hyphens are ignored).'
  }
  if (f.account_name.trim().length < 2) e.account_name = 'Enter the account holder name (at least 2 characters).'
  if (f.currency !== 'IDR' && f.currency !== 'USD') e.currency = 'Choose IDR or USD.'
  return e
}

/** Empty or non-numeric input is an error, never 0. */
export function parseRate(raw: string): { value?: number; error?: string } {
  const s = raw.replace(/[.,\s]/g, '')
  if (!s) return { error: 'Enter a rate.' }
  if (!/^\d+$/.test(s)) return { error: 'Digits only.' }
  const value = Number(s)
  if (value < RATE_MIN || value > RATE_MAX) return { error: rateRangeError() }
  return { value }
}
